<template>
  <v-container>
    <div class="RapportClient">
      <h1>Rapportage cliënt</h1>

      <v-text-field
        label="Cliëntnummer"
        v-model="zoekclientnummer"
        maxlength="20"
      ></v-text-field>
      <v-btn color="primary" @click="getClient()"> Ophalen </v-btn>

      <div class="button-bar" v-show="dataloaded">
        <a
          href="#"
          @click="perSessie()"
          class="a-tab"
          v-bind:class="{ selected: mode == 'sessie' }"
          >Per sessie</a
        >&nbsp;<a
          href="#"
          @click="perVraag()"
          class="a-tab"
          v-bind:class="{ selected: mode == 'vraag' }"
          >Per vraag</a
        >
      </div>
      <RapportagePerSessie
        :clientnummer="clientnummer"
        v-show="mode == 'sessie'"
        v-on:loaddata="onloaddata"
      ></RapportagePerSessie>
      <RapportagePerVraag
        :clientnummer="clientnummer"
        v-show="mode == 'vraag'"
        v-on:loaddata="onloaddata"
      ></RapportagePerVraag>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
import RapportagePerSessie from "@/components/RapportagePerSessie.vue";
import RapportagePerVraag from "@/components/RapportagePerVraag.vue";

export default {
  name: "RapportClient",
  components: {
    RapportagePerSessie,
    RapportagePerVraag,
  },
  data() {
    return {
      zoekclientnummer: "",
      clientnummer: "",
      mode: "sessie",
      dataloaded: false,
    };
  },
  methods: {
    getClient: function () {
      this.clientnummer = this.zoekclientnummer;
    },
    perSessie: function () {
      this.mode = "sessie";
    },
    perVraag: function () {
      this.mode = "vraag";
    },
    onloaddata: function (len) {
      this.dataloaded = len > 0;
    },
  },
  created: function () {
    if (this.$route.query.clientnummer) {
      this.zoekclientnummer = this.$route.query.clientnummer;
      this.getClient();
    }
  },
};
</script>

<style>
.a-tab {
  border: 2px solid #00b4d1;
  width: 350px;
  height: 28px;
  line-height: 28px;
  margin-right: 5px;
  margin-top: 15px;
  margin-bottom: 5px;
  text-align: center;
  display: inline-block;
  text-decoration: none;
  color: black !important;
  font-weight: bold;
  font-size: 13pt;
}

.a-tab:hover {
  background-color: #00b4d1;
}

.selected {
  background-color: #00b4d1;
  color: #fff;
}

.caption {
  font-weight: bold;
  font-size: larger;
}
.caption-field {
  margin-top: 10px;
  display: flex;
  line-height: 1.7;
}
</style>